import entry from './hero-laptop-screen.gif';
import heroPhoneStack from './hero-phone-stack.gif';

export default {
  entry,
  heroPhoneStack,
};
